export default __webpack_public_path__ + "static/media/cookies8.1be2cbb1.JPG";